import { FC, useState } from 'react';
import styled from 'styled-components';
import { Flex } from 'components/primitives/flex';
import { InputProps } from './types';

interface MessageProps extends InputProps {
  placeholder?: string;
  value?: string;
  onBlur?: (e) => void;
  onFocus?: (e) => void;
  hasValue?: boolean;
  inputComponent?: FC;
}

const MessageInput = (props: MessageProps) => {
  const {
    placeholder = 'Message',
    value,
    type,
    onChange,
    inputRef,
    onBlur,
    onFocus,
    hasValue,
    symbol,
    inputComponent,
  } = props;

  const [focus, setFocus] = useState(false);

  const onBlurAction = (e) => {
    if (onBlur) onBlur(e);
    setFocus(false);
  };

  const onFocusAction = (e) => {
    if (onFocus) onFocus(e);
    setFocus(true);
  };

  const getPropagatedProps = () => {
    const copy = { ...props };
    delete copy.hasValue;
    delete copy.hasError;
    delete copy.inputRef;

    return copy;
  };

  return (
    <Wrapper>
      {symbol && <Symbol>{symbol}</Symbol>}
      <MessageInputWrapper>
        {inputComponent ? (
          inputComponent({
            type: type || 'text',
            className: 'input',
            value,
            onBlur: onBlurAction,
            onFocus: onFocusAction,
            onChange,
            ref: inputRef,
            placeholder: '',
            ...getPropagatedProps(),
          })
        ) : (
          <MessageInputControl
            type={type || 'text'}
            className="input"
            value={value}
            onBlur={onBlurAction}
            onFocus={onFocusAction}
            onChange={onChange}
            ref={inputRef}
            {...getPropagatedProps()}
            placeholder=""
          />
        )}
        <Placeholder className={`${focus || hasValue || !!value ? 'placeholderUp' : ''}`}> {placeholder}</Placeholder>
      </MessageInputWrapper>
    </Wrapper>
  );
};

export default MessageInput;

const Wrapper = styled(Flex)``;

const Symbol = styled.div`
  //position: absolute;
  font-weight: 500;
  background: #f9fafe;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5e696a;
  height: auto;
  min-width: 35px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`;

const MessageInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const MessageInputControl = styled.input`
  // box-sizing: border-box;
  // width: 100%;
  // border-radius: 6px;
  // height: 50px;
  // font-weight: 400;
  // color: #17233c;
  // font-size: 16px;
  // line-height: 1.25;
  // border: none !important;
  // background-color: white;
  // padding: 12px 12px 8px 12px;
`;

const Placeholder = styled.div`
  position: absolute;
  top: 13px;
  left: 13px;
  pointer-events: none;
  transition: all 200ms ease;
  color: #5e696a;
  &.placeholderUp {
    font-size: 10px;
    top: 5px;
  }
`;
